import { VisitingHoursDepartmentResource } from './VisitingHoursDepartmentResource';
import { CMSResource } from 'app/resources/cmsresource';


export class VisitingHoursFieldsResource extends CMSResource{

    rid: number;
    visitingHoursDepartmentResource: VisitingHoursDepartmentResource;
    fieldRo: string;
    fieldEn: string;
    fieldFr: string;
    fieldDe: string;
    valueRo: string;
    valueEn: string;
    valueFr: string;
    valueDe: string;
    orderIndex: number;
    showDelete:boolean=false;
}